import { KeyCodeToKey, ShortcutsCategories, SpecKeys } from './Shortcuts.types'
import { isMacOS } from '../../util/general'

type ShortcutKeyMap = {
    [key: string]: string
}

export const getShortcutKeysMap = (): Record<string, Record<string, string>> => {
    const shortcuts = isMacOS() ? macShortcuts : windowsShortcuts

    const alphabetKeys = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    alphabetKeys.split('').forEach(key => {
        shortcuts[ShortcutsCategories.SECURITY_SEARCH][key] = key
    })

    return shortcuts
}

export enum GlobalShortcutsKeyName {
    openCloseTradePanel = 'openCloseTradePanel',
    placeMarketOrderBuy = 'placeMarketOrderBuy',
    placeMarketOrderSell = 'placeMarketOrderSell',
    placeLimitOrderBuy = 'placeLimitOrderBuy',
    placeLimitOrderSell = 'placeLimitOrderSell',
}

export enum ChartSettingsShortcutsKeyName {
    zoomIn = 'zoomIn',
    zoomOut = 'zoomOut',
    moveChartLeft = 'moveChartLeft',
    moveChartRight = 'moveChartRight',
    splitHorizontal = 'splitHorizontal',
    splitVertical = 'splitVertical',
    deleteCurrentWidget = 'deleteCurrentWidget',
}

export enum ScreenerScreenMenuShortcutsKeyName {
    nextSymbol = 'nextSymbol',
    previousSymbol = 'previousSymbol',
    flagUnflagSymbol = 'flagUnflagSymbol',
    selectAllSymbols = 'selectAllSymbols',
    selectNextSymbol = 'selectNextSymbol',
    selectPreviousSymbol = 'selectPreviousSymbol',
    createNewScreen = 'createNewScreen',
    saveScreen = 'saveScreen',
    loadScreen = 'loadScreen',
    saveAsScreen = 'saveAsScreen',
    addNewFilter = 'addNewFilter',
    addNewColumn = 'addNewColumn',
    maximizeScreener = 'maximizeScreener',
    undoScreener = 'undoScreener',
    redoScreener = 'redoScreener',
    discardScreenChanges = 'discardScreenChanges',
    exportScreen = 'exportScreen',
    renameScreen = 'renameScreen',
}

export enum WatchlistShortcutsKeyName {
    addToWatchlist = 'addToWatchlist',
    changeWatchlist = 'changeWatchlist',
    watchlistNextSymbol = 'watchlistNextSymbol',
    watchlistPreviousSymbol = 'watchlistPreviousSymbol',
    watchlistNextSymbolSpace = 'watchlistNextSymbolSpace',
    watchlistPreviousSymbolSpace = 'watchlistPreviousSymbolSpace',
    watchlistFlagUnflagSymbol = 'watchlistFlagUnflagSymbol',
    watchlistSelectAllSymbols = 'watchlistSelectAllSymbols',
    watchlistSelectNextSymbol = 'watchlistSelectNextSymbol',
    watchlistSelectPreviousSymbol = 'watchlistSelectPreviousSymbol',
}
export enum IndicatorsDrawingShortcutsKeyName {
    drawWithDemonstrationCursor = 'drawWithDemonstrationCursor',
    partiallyErase = 'partiallyErase',
    gannBoxFixedIncrements = 'gannBoxFixedIncrements',
    measureTool = 'measureTool',
    copySelectedObject = 'copySelectedObject',
    pasteObject = 'pasteObject',
    removeObject = 'removeObject',
    hideAllDrawings = 'hideAllDrawings',
    cloneDrawing = 'cloneDrawing',
    drawingsMultiSelect = 'drawingsMultiSelect',
    moveDrawingHorizontalVertical = 'moveDrawingHorizontalVertical',
    moveDrawingLeft = 'moveDrawingLeft',
    moveDrawingRight = 'moveDrawingRight',
    moveDrawingUp = 'moveDrawingUp',
    moveDrawingDown = 'moveDrawingDown',
    trendline = 'trendline',
    horizontalLine = 'horizontalLine',
    horizontalRay = 'horizontalRay',
    verticalLine = 'verticalLine',
    crossline = 'crossline',
    fibRetracement = 'fibRetracement',
    rectangle = 'rectangle',
    square = 'square',
    circle = 'circle',
    ellipse = 'ellipse',
}
export enum SecritySearchShortcuts {
    securitySearch = 'securitySearch',
    quickSearch = "quickSearch"

}

export enum ChartTypeShortcutsKeyName {
    openChartTypeMenu = 'openChartTypeMenu',
}

export enum AlertDialogShortcutsKeyName {
    openAlertDialog = 'openAlertDialog',
    saveAlertChanges = 'saveAlertChanges',
    nextAlert = 'nextAlert',
    previousAlert = 'previousAlert',
    nextAlertSpace = 'nextAlertSpace',
    previousAlertSpace = 'previousAlertSpace',
    selectAllAlerts = 'selectAllAlerts',
    selectNextAlert = 'selectNextAlert',
    selectPreviousAlert = 'selectPreviousAlert',
    removeAlertNoConfirm = 'removeAlertNoConfirm',
}

export enum IndicatorDialogShortcutsKeyName {
    openIndicatorDialog = 'openIndicatorDialog',
}

export enum ChartReplayShortcutsKeyName {
    openCloseChartReplayDialog = 'openCloseChartReplayDialog',
}

export enum MultiPaneMenuShortcutsKeyName {
    openMultiPaneMenu = 'openMultiPaneMenu',
    saveLayout = 'saveLayout',
}

export enum SaveMenuShortcutsKeyName {
    openSaveMenu = 'openSaveMenu',
    saveLayout = 'saveLayout',
}

export enum ChartShortcutsKeyName {
    showHideFullScreen = 'showHideFullScreen',
    resetChartView = 'resetChartView',
    showPlusButtonOnCursor = 'showPlusButtonOnCursor',
    scrollToRecentBar = 'scrollToRecentBar',
    zoomIn = 'zoomIn',
    zoomOut = 'zoomOut',
    panLeft = 'panLeft',
    panLeftFast = 'panLeftFast',
    panRight = 'panRight',
    panRightFast = 'panRightFast',
    openKeyboardShortcutsHelp = 'openKeyboardShortcutsHelp',
    moveToFirstBar = 'moveToFirstBar',
    moveToLastBar = 'moveToLastBar',
    moveToRealtimeBar = 'moveToRealtimeBar',
    undo = 'undo',
    redo = 'redo',
    addTextNote = 'addTextNote',
    saveChartImage = 'saveChartImage',
    replayStepForward = 'replayStepForward',
    replayPlayPause = 'replayPlayPause',
    goToDate = 'goToDate',
    toggleMaximizeChart = 'toggleMaximizeChart',
    switchNextChart = 'switchNextChart',
    switchPrevChart = 'switchPrevChart'
}

export enum ChartDurationShortcutKeyName {
    openChartDuration = 'openChartDuration',
}

export enum CustomTimeBucketShortcutsKeyName {
    openCustomTimeBucketIntervalDialog = 'openCustomTimeBucketIntervalDialog',
}

export enum QuickWidgetShortcutsKeyName {
    showHideQuickWidgets = 'showHideQuickWidgets',
    openQuickWidgetMarketDepth = 'openQuickWidgetMarketDepth',
    openQuickWidgetOrders = 'openQuickWidgetOrders',
    openQuickWidgetPositions = 'openQuickWidgetPositions',
    openQuickTradeWidget = 'openQuickTradeWidget'
}

export const macShortcuts: Record<string, ShortcutKeyMap> = {
    [ShortcutsCategories.INDICATORS_AND_DRAWINGS]: {
        [IndicatorsDrawingShortcutsKeyName.drawWithDemonstrationCursor]: `${SpecKeys.SHIFT}+${SpecKeys.META}`,
        [IndicatorsDrawingShortcutsKeyName.partiallyErase]: `${SpecKeys.META}+${SpecKeys.ALT}+E`,
        [IndicatorsDrawingShortcutsKeyName.gannBoxFixedIncrements]: `HOLD+${SpecKeys.SHIFT}`,
        [IndicatorsDrawingShortcutsKeyName.measureTool]: `HOLD+${SpecKeys.SHIFT}+${SpecKeys.CLICK}`,
        [IndicatorsDrawingShortcutsKeyName.copySelectedObject]: `${SpecKeys.META}+C`,
        [IndicatorsDrawingShortcutsKeyName.pasteObject]: `${SpecKeys.META}+V`,
        [IndicatorsDrawingShortcutsKeyName.removeObject]: `${SpecKeys.DELETE}`,
        [IndicatorsDrawingShortcutsKeyName.hideAllDrawings]: `${SpecKeys.META}+${SpecKeys.SHIFT}+H`,
        [IndicatorsDrawingShortcutsKeyName.cloneDrawing]: `${SpecKeys.META}+${SpecKeys.DRAG}`,
        [IndicatorsDrawingShortcutsKeyName.drawingsMultiSelect]: `HOLD+${SpecKeys.META}+${SpecKeys.CLICK}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingHorizontalVertical]: `${SpecKeys.DRAG}+${SpecKeys.SHIFT}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingLeft]:`${SpecKeys.ARROW_LEFT}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingRight]: `${SpecKeys.ARROW_RIGHT}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingUp]: `${SpecKeys.ARROW_UP}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingDown]: `${SpecKeys.ARROW_DOWN}`,
        [IndicatorsDrawingShortcutsKeyName.trendline]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+T`,
        [IndicatorsDrawingShortcutsKeyName.horizontalLine]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+H`,
        [IndicatorsDrawingShortcutsKeyName.horizontalRay]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+J`,
        [IndicatorsDrawingShortcutsKeyName.verticalLine]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+V`,
        [IndicatorsDrawingShortcutsKeyName.crossline]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+C`,
        [IndicatorsDrawingShortcutsKeyName.fibRetracement]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+F`,
        [IndicatorsDrawingShortcutsKeyName.rectangle]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+R`,
        [IndicatorsDrawingShortcutsKeyName.ellipse]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+E`,
        [IndicatorsDrawingShortcutsKeyName.square]: `RECTANGLE+${SpecKeys.SHIFT}`,
        [IndicatorsDrawingShortcutsKeyName.circle]: `ELLIPSE+${SpecKeys.SHIFT}`,

    },
    [ShortcutsCategories.GLOBAL]: {
        // [GlobalShortcutsKeyName.openCloseTradePanel]: `${SpecKeys.SHIFT}+T`,
        [GlobalShortcutsKeyName.placeMarketOrderBuy]: `${SpecKeys.SHIFT}+B`,
        [GlobalShortcutsKeyName.placeMarketOrderSell]: `${SpecKeys.SHIFT}+S`,
        [GlobalShortcutsKeyName.placeLimitOrderBuy]: `${SpecKeys.SHIFT}+${SpecKeys.ALT}+B`,
        [GlobalShortcutsKeyName.placeLimitOrderSell]: `${SpecKeys.SHIFT}+${SpecKeys.ALT}+S`
    },
    [ShortcutsCategories.ALERT_DIALOG]: {
        [AlertDialogShortcutsKeyName.openAlertDialog]: `${SpecKeys.ALT}+A`,
        [AlertDialogShortcutsKeyName.saveAlertChanges]: `${SpecKeys.META}+${KeyCodeToKey.Enter}`,
        [AlertDialogShortcutsKeyName.nextAlert]: `${KeyCodeToKey.ArrowDown}`,
        [AlertDialogShortcutsKeyName.previousAlert]: `${KeyCodeToKey.ArrowUp}`,
        [AlertDialogShortcutsKeyName.nextAlertSpace]: `${KeyCodeToKey.Space}`,
        [AlertDialogShortcutsKeyName.previousAlertSpace]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Space}`,
        [AlertDialogShortcutsKeyName.selectAllAlerts]: `${SpecKeys.META}+A`,
        [AlertDialogShortcutsKeyName.selectNextAlert]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowDown}`,
        [AlertDialogShortcutsKeyName.selectPreviousAlert]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowUp}`,
        [AlertDialogShortcutsKeyName.removeAlertNoConfirm]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Backspace}`,
    },
    [ShortcutsCategories.INDICATOR_DIALOG]: {
        [IndicatorDialogShortcutsKeyName.openIndicatorDialog]: '/'
    },
    [ShortcutsCategories.MULTI_PANE_MENU]: {
        [MultiPaneMenuShortcutsKeyName.openMultiPaneMenu]: '.',
        [MultiPaneMenuShortcutsKeyName.saveLayout]: `${SpecKeys.META}+S`
    },
    [ShortcutsCategories.SAVE_MENU]: {
        [SaveMenuShortcutsKeyName.openSaveMenu]: `${SpecKeys.CONTROL}+P`,
        [SaveMenuShortcutsKeyName.saveLayout]: `${SpecKeys.META}+S`
    },
    [ShortcutsCategories.CHART_DURATION]: {
        [ChartDurationShortcutKeyName.openChartDuration]: `${SpecKeys.ALT}+G`
    },
    [ShortcutsCategories.CHART]: {
        [ChartShortcutsKeyName.showHideFullScreen]: `${SpecKeys.SHIFT}+F`,
        [ChartShortcutsKeyName.resetChartView]: `${SpecKeys.ALT}+R`,
        [ChartShortcutsKeyName.showPlusButtonOnCursor]: `${SpecKeys.ALT}+${SpecKeys.META}`,
        [ChartShortcutsKeyName.scrollToRecentBar]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.zoomIn]: `${SpecKeys.META}+${KeyCodeToKey.ArrowUp}`,
        [ChartShortcutsKeyName.zoomOut]: `${SpecKeys.META}+${KeyCodeToKey.ArrowDown}`,
        [ChartShortcutsKeyName.panLeft]: `${KeyCodeToKey.ArrowLeft}`,
        [ChartShortcutsKeyName.panRight]: `${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.panLeftFast]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowLeft}`,
        [ChartShortcutsKeyName.panRightFast]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.openKeyboardShortcutsHelp]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Slash}`,
        [ChartShortcutsKeyName.moveToFirstBar]: `${SpecKeys.ALT}+${SpecKeys.META}+${KeyCodeToKey.ArrowLeft}`,
        [ChartShortcutsKeyName.moveToLastBar]: `${SpecKeys.ALT}+${SpecKeys.META}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.moveToRealtimeBar]: `${SpecKeys.META}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.undo]: `${SpecKeys.META}+Z`,
        [ChartShortcutsKeyName.redo]: `${SpecKeys.META}+Y`,
        [ChartShortcutsKeyName.toggleMaximizeChart]: `${SpecKeys.ALT}+${KeyCodeToKey.Enter}`,
        [ChartShortcutsKeyName.replayPlayPause]: `${SpecKeys.META}+${KeyCodeToKey.ArrowDown}`,
        [ChartShortcutsKeyName.replayStepForward]: `${SpecKeys.META}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.switchNextChart]: `${KeyCodeToKey.Tab}`,
        [ChartShortcutsKeyName.switchPrevChart]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Tab}`,
        [ChartShortcutsKeyName.addTextNote]: `${SpecKeys.ALT}+N`,
        [ChartShortcutsKeyName.saveChartImage]: `${SpecKeys.ALT}+${SpecKeys.META}+S`,
        [ChartShortcutsKeyName.goToDate]: `${SpecKeys.ALT}+G`,
    },
    [ShortcutsCategories.SECURITY_SEARCH]: { [SecritySearchShortcuts.securitySearch]: `${SpecKeys.SHIFT}+C` },
    [ShortcutsCategories.QUICK_SEARCH]: { [SecritySearchShortcuts.quickSearch]: `${SpecKeys.META}+K` },

    [ShortcutsCategories.CUSTOM_TIME_INTERVAL]: {
        [CustomTimeBucketShortcutsKeyName.openCustomTimeBucketIntervalDialog]: `,`
    },
    [ShortcutsCategories.ADD_TO_WATCHLIST]: {
        [WatchlistShortcutsKeyName.addToWatchlist]: `${SpecKeys.ALT}+W`
    },
    [ShortcutsCategories.WATCHLIST]: {
        [WatchlistShortcutsKeyName.changeWatchlist]: `${SpecKeys.SHIFT}+W`,
        [WatchlistShortcutsKeyName.watchlistNextSymbol]: `${KeyCodeToKey.ArrowDown}`,
        [WatchlistShortcutsKeyName.watchlistPreviousSymbol]: `${KeyCodeToKey.ArrowUp}`,
        [WatchlistShortcutsKeyName.watchlistNextSymbolSpace]: `${KeyCodeToKey.Space}`,
        [WatchlistShortcutsKeyName.watchlistPreviousSymbolSpace]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Space}`,
        [WatchlistShortcutsKeyName.watchlistFlagUnflagSymbol]: `${SpecKeys.ALT}+${KeyCodeToKey.Enter}`,
        [WatchlistShortcutsKeyName.watchlistSelectAllSymbols]: `${SpecKeys.META}+A`,
        [WatchlistShortcutsKeyName.watchlistSelectNextSymbol]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowDown}`,
        [WatchlistShortcutsKeyName.watchlistSelectPreviousSymbol]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowUp}`,
    },
    [ShortcutsCategories.CHART_REPLAY]: {
        [ChartReplayShortcutsKeyName.openCloseChartReplayDialog]: `${SpecKeys.SHIFT}+R`
    },
    [ShortcutsCategories.CHART_TYPE]: {
        [ChartTypeShortcutsKeyName.openChartTypeMenu]: `${SpecKeys.ALT}+T`
    },
    [ShortcutsCategories.SCREENER]: {
        [ScreenerScreenMenuShortcutsKeyName.nextSymbol]: `${KeyCodeToKey.ArrowDown}`,
        [ScreenerScreenMenuShortcutsKeyName.previousSymbol]: `${KeyCodeToKey.ArrowUp}`,
        [ScreenerScreenMenuShortcutsKeyName.flagUnflagSymbol]: `${SpecKeys.ALT}+${KeyCodeToKey.Enter}`,
        [ScreenerScreenMenuShortcutsKeyName.selectAllSymbols]: `${SpecKeys.META}+A`,
        [ScreenerScreenMenuShortcutsKeyName.selectNextSymbol]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowDown}`,
        [ScreenerScreenMenuShortcutsKeyName.selectPreviousSymbol]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowUp}`,
        [ScreenerScreenMenuShortcutsKeyName.createNewScreen]: `${SpecKeys.SHIFT}+N`,
        [ScreenerScreenMenuShortcutsKeyName.saveScreen]: `${SpecKeys.META}+S`,
        [ScreenerScreenMenuShortcutsKeyName.loadScreen]: `${KeyCodeToKey.Period}`,
        [ScreenerScreenMenuShortcutsKeyName.saveAsScreen]: `${SpecKeys.META}+${SpecKeys.SHIFT}+S`,
        [ScreenerScreenMenuShortcutsKeyName.addNewFilter]: `${SpecKeys.SHIFT}+F`,
        [ScreenerScreenMenuShortcutsKeyName.addNewColumn]: `${SpecKeys.SHIFT}+C`,
        [ScreenerScreenMenuShortcutsKeyName.maximizeScreener]: `${SpecKeys.SHIFT}+M`,
        [ScreenerScreenMenuShortcutsKeyName.undoScreener]: `${SpecKeys.META}+Z`,
        [ScreenerScreenMenuShortcutsKeyName.redoScreener]: `${SpecKeys.META}+Y`,
        [ScreenerScreenMenuShortcutsKeyName.discardScreenChanges]: `${SpecKeys.ALT}+D`,
        [ScreenerScreenMenuShortcutsKeyName.exportScreen]: `${SpecKeys.ALT}+E`,
        [ScreenerScreenMenuShortcutsKeyName.renameScreen]: `${SpecKeys.ALT}+R`
    },
    [ShortcutsCategories.CHART_SETTINGS]: {
        [ChartSettingsShortcutsKeyName.zoomIn]: `${SpecKeys.META}+${KeyCodeToKey.ArrowUp}`,
        [ChartSettingsShortcutsKeyName.zoomOut]: `${SpecKeys.META}+${KeyCodeToKey.ArrowDown}`,
        [ChartSettingsShortcutsKeyName.moveChartLeft]: `${KeyCodeToKey.ArrowLeft}`,
        [ChartSettingsShortcutsKeyName.moveChartRight]: `${KeyCodeToKey.ArrowRight}`,
        [ChartSettingsShortcutsKeyName.splitVertical]: `${SpecKeys.META}+V`,
        [ChartSettingsShortcutsKeyName.splitHorizontal]: `${SpecKeys.META}+H`,
        [ChartSettingsShortcutsKeyName.deleteCurrentWidget]: `${SpecKeys.META}+${KeyCodeToKey.Backspace || KeyCodeToKey.Delete}`
    },
    [ShortcutsCategories.QUICK_WIDGETS]: {
        [QuickWidgetShortcutsKeyName.showHideQuickWidgets]: `${SpecKeys.SHIFT}+Q`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetMarketDepth]: `${SpecKeys.SHIFT}+D`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetOrders]: `${SpecKeys.SHIFT}+O`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetPositions]: `${SpecKeys.SHIFT}+P`,
        [QuickWidgetShortcutsKeyName.openQuickTradeWidget]: `${SpecKeys.SHIFT}+T`
    }
}

export const windowsShortcuts: Record<string, ShortcutKeyMap> = {
    [ShortcutsCategories.GLOBAL]: {
        // [GlobalShortcutsKeyName.openCloseTradePanel]: `${SpecKeys.SHIFT}+T`,
        [GlobalShortcutsKeyName.placeMarketOrderBuy]: `${SpecKeys.SHIFT}+B`,
        [GlobalShortcutsKeyName.placeMarketOrderSell]: `${SpecKeys.SHIFT}+S`,
        [GlobalShortcutsKeyName.placeLimitOrderBuy]: `${SpecKeys.SHIFT}+${SpecKeys.ALT}+B`,
        [GlobalShortcutsKeyName.placeLimitOrderSell]: `${SpecKeys.SHIFT}+${SpecKeys.ALT}+S`
    },
    [ShortcutsCategories.ALERT_DIALOG]: {
        [AlertDialogShortcutsKeyName.openAlertDialog]: `${SpecKeys.ALT}+A`,
        [AlertDialogShortcutsKeyName.saveAlertChanges]: `${SpecKeys.CONTROL}+${KeyCodeToKey.Enter}`,
        [AlertDialogShortcutsKeyName.nextAlert]: `${KeyCodeToKey.ArrowDown}`,
        [AlertDialogShortcutsKeyName.previousAlert]: `${KeyCodeToKey.ArrowUp}`,
        [AlertDialogShortcutsKeyName.nextAlertSpace]: `${KeyCodeToKey.Space}`,
        [AlertDialogShortcutsKeyName.previousAlertSpace]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Space}`,
        [AlertDialogShortcutsKeyName.selectAllAlerts]: `${SpecKeys.CONTROL}+A`,
        [AlertDialogShortcutsKeyName.selectNextAlert]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowDown}`,
        [AlertDialogShortcutsKeyName.selectPreviousAlert]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowUp}`,
        [AlertDialogShortcutsKeyName.removeAlertNoConfirm]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Delete}`,
    },
    [ShortcutsCategories.INDICATOR_DIALOG]: {
        [IndicatorDialogShortcutsKeyName.openIndicatorDialog]: '/'
    },
    [ShortcutsCategories.MULTI_PANE_MENU]: {
        [MultiPaneMenuShortcutsKeyName.openMultiPaneMenu]: '.',
        [MultiPaneMenuShortcutsKeyName.saveLayout]: `${SpecKeys.CONTROL}+S`
    },
    [ShortcutsCategories.SAVE_MENU]: {
        [SaveMenuShortcutsKeyName.openSaveMenu]: `${SpecKeys.CONTROL}+P`,
        [SaveMenuShortcutsKeyName.saveLayout]: `${SpecKeys.META}+S`
    },
    [ShortcutsCategories.CHART]: {
        [ChartShortcutsKeyName.resetChartView]: `${SpecKeys.ALT}+R`,
        [ChartShortcutsKeyName.showPlusButtonOnCursor]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}`,
        [ChartShortcutsKeyName.scrollToRecentBar]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.zoomIn]: `${SpecKeys.CONTROL}+${KeyCodeToKey.ArrowUp}`,
        [ChartShortcutsKeyName.zoomOut]: `${SpecKeys.CONTROL}+${KeyCodeToKey.ArrowDown}`,
        [ChartShortcutsKeyName.panLeft]: `${KeyCodeToKey.ArrowLeft}`,
        [ChartShortcutsKeyName.panRight]: `${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.panLeftFast]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowLeft}`,
        [ChartShortcutsKeyName.panRightFast]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.openKeyboardShortcutsHelp]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Slash}`,
        [ChartShortcutsKeyName.moveToFirstBar]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowLeft}`,
        [ChartShortcutsKeyName.moveToLastBar]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.moveToRealtimeBar]: `${SpecKeys.CONTROL}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.undo]: `${SpecKeys.CONTROL}+Z`,
        [ChartShortcutsKeyName.redo]: `${SpecKeys.CONTROL}+Y`,
        [ChartShortcutsKeyName.toggleMaximizeChart]: `${SpecKeys.ALT}+${KeyCodeToKey.Enter}`,
        [ChartShortcutsKeyName.replayPlayPause]: `${SpecKeys.CONTROL}+${KeyCodeToKey.ArrowDown}`,
        [ChartShortcutsKeyName.replayStepForward]: `${SpecKeys.CONTROL}+${KeyCodeToKey.ArrowRight}`,
        [ChartShortcutsKeyName.switchNextChart]: `${KeyCodeToKey.Tab}`,
        [ChartShortcutsKeyName.switchPrevChart]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Tab}`,
        [ChartShortcutsKeyName.addTextNote]: `${SpecKeys.ALT}+N`,
        [ChartShortcutsKeyName.saveChartImage]: `${SpecKeys.ALT}+${SpecKeys.CONTROL}+S`,
        [ChartShortcutsKeyName.goToDate]: `${SpecKeys.ALT}+G`,
    },
    [ShortcutsCategories.CHART_DURATION]: {
        [ChartDurationShortcutKeyName.openChartDuration]: `${SpecKeys.ALT}+G`
    },
    [ShortcutsCategories.SECURITY_SEARCH]: {},
    [ShortcutsCategories.QUICK_SEARCH]: { [SecritySearchShortcuts.quickSearch]: `${SpecKeys.META}+K` },
    [ShortcutsCategories.CUSTOM_TIME_INTERVAL]: {
        [CustomTimeBucketShortcutsKeyName.openCustomTimeBucketIntervalDialog]: `,`
    },
    [ShortcutsCategories.ADD_TO_WATCHLIST]: {
        [WatchlistShortcutsKeyName.addToWatchlist]: `${SpecKeys.ALT}+W`
    },
    [ShortcutsCategories.WATCHLIST]: {
        [WatchlistShortcutsKeyName.changeWatchlist]: `${SpecKeys.SHIFT}+W`,
        [WatchlistShortcutsKeyName.watchlistNextSymbol]: `${KeyCodeToKey.ArrowDown}`,
        [WatchlistShortcutsKeyName.watchlistPreviousSymbol]: `${KeyCodeToKey.ArrowUp}`,
        [WatchlistShortcutsKeyName.watchlistNextSymbolSpace]: `${KeyCodeToKey.Space}`,
        [WatchlistShortcutsKeyName.watchlistPreviousSymbolSpace]: `${SpecKeys.SHIFT}+${KeyCodeToKey.Space}`,
        [WatchlistShortcutsKeyName.watchlistFlagUnflagSymbol]: `${SpecKeys.ALT}+${KeyCodeToKey.Enter}`,
        [WatchlistShortcutsKeyName.watchlistSelectAllSymbols]: `${SpecKeys.CONTROL}+A`,
        [WatchlistShortcutsKeyName.watchlistSelectNextSymbol]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowDown}`,
        [WatchlistShortcutsKeyName.watchlistSelectPreviousSymbol]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowUp}`,
    },
    [ShortcutsCategories.CHART_REPLAY]: {
        [ChartReplayShortcutsKeyName.openCloseChartReplayDialog]: `${SpecKeys.SHIFT}+R`
    },
    [ShortcutsCategories.CHART_TYPE]: {
        [ChartTypeShortcutsKeyName.openChartTypeMenu]: `${SpecKeys.ALT}+T`
    },
    [ShortcutsCategories.SCREENER]: {
        [ScreenerScreenMenuShortcutsKeyName.nextSymbol]: `${KeyCodeToKey.ArrowDown}`,
        [ScreenerScreenMenuShortcutsKeyName.previousSymbol]: `${KeyCodeToKey.ArrowUp}`,
        [ScreenerScreenMenuShortcutsKeyName.flagUnflagSymbol]: `${SpecKeys.ALT}+${KeyCodeToKey.Enter}`,
        [ScreenerScreenMenuShortcutsKeyName.selectAllSymbols]: `${SpecKeys.CONTROL}+A`,
        [ScreenerScreenMenuShortcutsKeyName.selectNextSymbol]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowDown}`,
        [ScreenerScreenMenuShortcutsKeyName.selectPreviousSymbol]: `${SpecKeys.SHIFT}+${KeyCodeToKey.ArrowUp}`,
        [ScreenerScreenMenuShortcutsKeyName.createNewScreen]: `${SpecKeys.SHIFT}+N`,
        [ScreenerScreenMenuShortcutsKeyName.saveScreen]: `${SpecKeys.CONTROL}+S`,
        // [ScreenerScreenMenuShortcutsKeyName.loadScreen]: `${KeyCodeToKey.Period}`,
        [ScreenerScreenMenuShortcutsKeyName.saveAsScreen]: `${SpecKeys.CONTROL}+${SpecKeys.SHIFT}+S`,
        // [ScreenerScreenMenuShortcutsKeyName.addNewFilter]: `${SpecKeys.SHIFT}+F`,
        // [ScreenerScreenMenuShortcutsKeyName.addNewColumn]: `${SpecKeys.SHIFT}+C`,
        // [ScreenerScreenMenuShortcutsKeyName.maximizeScreener]: `${SpecKeys.SHIFT}+M`,
        // [ScreenerScreenMenuShortcutsKeyName.undoScreener]: `${SpecKeys.CONTROL}+Z`,
        // [ScreenerScreenMenuShortcutsKeyName.redoScreener]: `${SpecKeys.CONTROL}+Y`,
        [ScreenerScreenMenuShortcutsKeyName.discardScreenChanges]: `${SpecKeys.ALT}+D`,
        [ScreenerScreenMenuShortcutsKeyName.exportScreen]: `${SpecKeys.ALT}+E`,
        [ScreenerScreenMenuShortcutsKeyName.renameScreen]: `${SpecKeys.ALT}+R`
    },
    [ShortcutsCategories.CHART_SETTINGS]: {
        [ChartSettingsShortcutsKeyName.zoomIn]: `${SpecKeys.META}+${KeyCodeToKey.ArrowUp}`,
        [ChartSettingsShortcutsKeyName.zoomOut]: `${SpecKeys.META}+${KeyCodeToKey.ArrowDown}`,
        [ChartSettingsShortcutsKeyName.moveChartLeft]: `${KeyCodeToKey.ArrowLeft}`,
        [ChartSettingsShortcutsKeyName.moveChartRight]: `${KeyCodeToKey.ArrowRight}`,
        [ChartSettingsShortcutsKeyName.splitVertical]: `${SpecKeys.META}+V`,
        [ChartSettingsShortcutsKeyName.splitHorizontal]: `${SpecKeys.META}+H`,
        [ChartSettingsShortcutsKeyName.deleteCurrentWidget]: `${SpecKeys.META}+${KeyCodeToKey.Backspace || KeyCodeToKey.Delete}`
    },
    [ShortcutsCategories.QUICK_WIDGETS]: {
        [QuickWidgetShortcutsKeyName.showHideQuickWidgets]: `${SpecKeys.SHIFT}+Q`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetMarketDepth]: `${SpecKeys.SHIFT}+D`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetOrders]: `${SpecKeys.SHIFT}+O`,
        [QuickWidgetShortcutsKeyName.openQuickWidgetPositions]: `${SpecKeys.SHIFT}+P`,
        [QuickWidgetShortcutsKeyName.openQuickTradeWidget]: `${SpecKeys.SHIFT}+T`,
    },
    [ShortcutsCategories.INDICATORS_AND_DRAWINGS]: {
        [IndicatorsDrawingShortcutsKeyName.drawWithDemonstrationCursor]: `${SpecKeys.SHIFT}+${SpecKeys.CONTROL}`,
        [IndicatorsDrawingShortcutsKeyName.partiallyErase]: `${SpecKeys.CONTROL}+${SpecKeys.ALT}+E`,
        [IndicatorsDrawingShortcutsKeyName.gannBoxFixedIncrements]: `HOLD+${SpecKeys.SHIFT}`,
        [IndicatorsDrawingShortcutsKeyName.measureTool]: `HOLD+${SpecKeys.SHIFT}+${SpecKeys.CLICK}`,
        [IndicatorsDrawingShortcutsKeyName.copySelectedObject]: `${SpecKeys.CONTROL}+C`,
        [IndicatorsDrawingShortcutsKeyName.pasteObject]: `${SpecKeys.CONTROL}+V`,
        [IndicatorsDrawingShortcutsKeyName.removeObject]: `${SpecKeys.DELETE}`,
        [IndicatorsDrawingShortcutsKeyName.hideAllDrawings]: `${SpecKeys.CONTROL}+${SpecKeys.SHIFT}+H`,
        [IndicatorsDrawingShortcutsKeyName.cloneDrawing]: `${SpecKeys.CONTROL}+${SpecKeys.DRAG}`,
        [IndicatorsDrawingShortcutsKeyName.drawingsMultiSelect]: `HOLD+${SpecKeys.CONTROL}+${SpecKeys.CLICK}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingHorizontalVertical]: `${SpecKeys.DRAG}+${SpecKeys.SHIFT}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingLeft]: `${SpecKeys.ARROW_LEFT}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingRight]: `${SpecKeys.ARROW_RIGHT}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingUp]: `${SpecKeys.ARROW_UP}`,
        [IndicatorsDrawingShortcutsKeyName.moveDrawingDown]: `${SpecKeys.ARROW_DOWN}`,
        [IndicatorsDrawingShortcutsKeyName.trendline]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+T`,
        [IndicatorsDrawingShortcutsKeyName.horizontalLine]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+H`,
        [IndicatorsDrawingShortcutsKeyName.horizontalRay]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+J`,
        [IndicatorsDrawingShortcutsKeyName.verticalLine]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+V`,
        [IndicatorsDrawingShortcutsKeyName.crossline]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+C`,
        [IndicatorsDrawingShortcutsKeyName.fibRetracement]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+F`,
        [IndicatorsDrawingShortcutsKeyName.rectangle]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+R`,
        [IndicatorsDrawingShortcutsKeyName.ellipse]: `${SpecKeys.ALT}+${SpecKeys.SHIFT}+E`,
        [IndicatorsDrawingShortcutsKeyName.square]: `RECTANGLE+${SpecKeys.SHIFT}`,
        [IndicatorsDrawingShortcutsKeyName.circle]: `ELLIPSE+${SpecKeys.SHIFT}`,
    }
}